import { gql } from '@apollo/client'
import PropTypes from '~/lib/propTypes'
import { stateStepFragment, stateStepFragmentPropTypes } from './stateStep'

export const stateFragment = gql`
  fragment state on DraftState {
    valid
    readyToPublish
    event {
      ...stateStep
    }
    tickets {
      ...stateStep
    }
    originalPrice {
      ...stateStep
    }
    sellingPrice {
      ...stateStep
    }
    personalInformation {
      ...stateStep
    }
    phoneNumber {
      ...stateStep
    }
    payout {
      ...stateStep
    }
    knowYourCustomer {
      ...stateStep
    }
    verification {
      ...stateStep
    }
  }

  ${stateStepFragment}
`

export const stepsFragmentPropTypes = PropTypes.oneOf([
  'EVENT',
  'FILES',
  'TICKET_INFO',
  'LISTING',
  'SELLING_PRICE',
  'PERSONAL_DETAILS',
  'PHONE_DETAILS',
  'PAYOUT_INFORMATION',
  'VERIFY_IDENTITY',
  'SUMMARY',
])

export const stateFragmentPropTypes = PropTypes.shape({
  valid: PropTypes.bool,
  readyToPublish: PropTypes.bool,
  event: stateStepFragmentPropTypes,
  tickets: stateStepFragmentPropTypes,
  originalPrice: stateStepFragmentPropTypes,
  sellingPrice: stateStepFragmentPropTypes,
  personalInformation: stateStepFragmentPropTypes,
  phoneNumber: stateStepFragmentPropTypes,
  payout: stateStepFragmentPropTypes,
  social: stateStepFragmentPropTypes,
  verification: stateStepFragmentPropTypes,
  knowYourCustomer: stateStepFragmentPropTypes,
})
